<template>
  <div class="table-filter">
    <div class="flex justify-between items-center">
      <p>EDIT TABLE COLUMNS</p>
      <span>
        <svg
          width="11"
          height="12"
          viewBox="0 0 11 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.00463867 0H1.59781V2.03694C2.54576 1.29206 3.7411 0.847806 5.04021 0.847806C8.1198 0.847806 10.6163 3.34431 10.6163 6.4239C10.6163 9.5035 8.1198 12 5.04021 12C3.32716 12 1.79453 11.2275 0.771663 10.0119L2.06159 9.06812C2.79118 9.88938 3.85527 10.4068 5.04021 10.4068C7.23992 10.4068 9.02313 8.62361 9.02313 6.4239C9.02313 4.22419 7.23992 2.44098 5.04021 2.44098C4.17444 2.44098 3.3732 2.71721 2.7198 3.18634L4.78415 3.18634V4.77951H0.00463867V0Z"
            fill="#10233E"
          />
        </svg>
      </span>
    </div>
    <hr class="my-2" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-6">
          <div class="flex justify-between items-center cursor-pointer">
            <div class="flex items-center justify-between">
              <span><drag-icon /></span>
              <span class="text-sm">Shipping Reference</span>
            </div>
            <div
              class="cursor-pointer"
              @click="$emit('update-table', 'shippingReference')"
            >
              <span><view-icon /></span>
            </div>
          </div>
          <div class="flex justify-between items-center cursor-pointer">
            <div class="flex items-center justify-between">
              <span><drag-icon /></span>
              <span class="text-sm">Shipment Date</span>
            </div>
            <div>
              <span><view-icon /></span>
            </div>
          </div>
          <div class="flex justify-between items-center cursor-pointer">
            <div class="flex items-center justify-between">
              <span><drag-icon /></span>
              <span class="text-sm">Booking Channel</span>
            </div>
            <div>
              <span><view-icon /></span>
            </div>
          </div>
          <div class="flex justify-between items-center cursor-pointer">
            <div class="flex items-center justify-between">
              <span><drag-icon /></span>
              <span class="text-sm">Shipper</span>
            </div>
            <div>
              <span><view-icon /></span>
            </div>
          </div>
          <div class="flex justify-between items-center cursor-pointer">
            <div class="flex items-center justify-between">
              <span><drag-icon /></span>
              <span class="text-sm">Consignee</span>
            </div>
            <div>
              <span><view-icon /></span>
            </div>
          </div>
          <div class="flex justify-between items-center cursor-pointer">
            <div class="flex items-center justify-between">
              <span><drag-icon /></span>
              <span class="text-sm">Ship From</span>
            </div>
            <div>
              <span><view-icon /></span>
            </div>
          </div>
          <hr />
          <div class="inactive-filters">
            <div class="flex justify-between items-center cursor-pointer">
              <div class="flex items-center justify-between">
                <span><drag-icon /></span>
                <span class="text-sm">Routing</span>
              </div>
              <div
                class="cursor-pointer"
                @click="$emit('update-table', 'routing')"
              >
                <span><view-icon /></span>
              </div>
            </div>
            <div class="flex justify-between items-center cursor-pointer">
              <div class="flex items-center justify-between">
                <span><drag-icon /></span>
                <span class="text-sm">Hand-off Processing</span>
              </div>
              <div
                class="cursor-pointer"
                @click="$emit('update-table', 'handOff')"
              >
                <span><view-icon /></span>
              </div>
            </div>
            <div class="flex justify-between items-center cursor-pointer">
              <div class="flex items-center justify-between">
                <span><drag-icon /></span>
                <span class="text-sm">Receive From</span>
              </div>
              <div
                class="cursor-pointer"
                @click="$emit('update-table', 'receiveFrom')"
              >
                <span><view-icon /></span>
              </div>
            </div>
            <div class="flex justify-between items-center cursor-pointer">
              <div class="flex items-center justify-between">
                <span><drag-icon /></span>
                <span class="text-sm">Deliver To</span>
              </div>
              <div
                class="cursor-pointer"
                @click="$emit('update-table', 'deliverTo')"
              >
                <span><view-icon /></span>
              </div>
            </div>
            <div class="flex justify-between items-center cursor-pointer">
              <div class="flex items-center justify-between">
                <span><drag-icon /></span>
                <span class="text-sm">Distance (Km)</span>
              </div>
              <div
                class="cursor-pointer"
                @click="$emit('update-table', 'distance')"
              >
                <span><view-icon /></span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="flex justify-between items-center cursor-pointer">
            <div class="flex items-center justify-between">
              <span><drag-icon /></span>
              <span class="text-sm">Pickup Date</span>
            </div>
            <div
              class="cursor-pointer"
              @click="$emit('update-table', 'pickUpDate')"
            >
              <span><view-icon /></span>
            </div>
          </div>
          <div class="flex justify-between items-center cursor-pointer">
            <div class="flex items-center justify-between">
              <span><drag-icon /></span>
              <span class="text-sm">Ship To</span>
            </div>
            <div
              class="cursor-pointer"
              @click="$emit('update-table', 'shipTo')"
            >
              <span><view-icon /></span>
            </div>
          </div>
          <div class="flex justify-between items-center cursor-pointer">
            <div class="flex items-center justify-between">
              <span><drag-icon /></span>
              <span class="text-sm">Estimated Drop Date</span>
            </div>
            <div
              class="cursor-pointer"
              @click="$emit('update-table', 'dropDate')"
            >
              <span><view-icon /></span>
            </div>
          </div>
          <div class="flex justify-between items-center cursor-pointer">
            <div class="flex items-center justify-between">
              <span><drag-icon /></span>
              <span class="text-sm">Pickup Time</span>
            </div>
            <div
              class="cursor-pointer"
              @click="$emit('update-table', 'pickUpTime')"
            >
              <span><view-icon /></span>
            </div>
          </div>
          <div class="flex justify-between items-center cursor-pointer">
            <div class="flex items-center justify-between">
              <span><drag-icon /></span>
              <span class="text-sm">Est. Drop-off Time</span>
            </div>
            <div
              class="cursor-pointer"
              @click="$emit('update-table', 'dropOffTime')"
            >
              <span><view-icon /></span>
            </div>
          </div>
          <div class="flex justify-between items-center cursor-pointer">
            <div class="flex items-center justify-between">
              <span><drag-icon /></span>
              <span class="text-sm">Status</span>
            </div>
            <div>
              <span><view-icon /></span>
            </div>
          </div>
          <hr />
          <div class="inactive-filters">
            <div class="flex justify-between items-center cursor-pointer">
              <div class="flex items-center justify-between">
                <span><drag-icon /></span>
                <span class="text-sm">Load Weight (Kg)</span>
              </div>
              <div
                class="cursor-pointer"
                @click="$emit('update-table', 'weight')"
              >
                <span><view-icon /></span>
              </div>
            </div>
            <div class="flex justify-between items-center cursor-pointer">
              <div class="flex items-center justify-between">
                <span><drag-icon /></span>
                <span class="text-sm">Income</span>
              </div>
              <div
                class="cursor-pointer"
                @click="$emit('update-table', 'income')"
              >
                <span><view-icon /></span>
              </div>
            </div>
            <div class="flex justify-between items-center cursor-pointer">
              <div class="flex items-center justify-between">
                <span><drag-icon /></span>
                <span class="text-sm">Fleet</span>
              </div>
              <div
                class="cursor-pointer"
                @click="$emit('update-table', 'fleet')"
              >
                <span><view-icon /></span>
              </div>
            </div>
            <div class="flex justify-between items-center cursor-pointer">
              <div class="flex items-center justify-between">
                <span><drag-icon /></span>
                <span class="text-sm">Driver</span>
              </div>
              <div
                class="cursor-pointer"
                @click="$emit('update-table', 'driver')"
              >
                <span><view-icon /></span>
              </div>
            </div>
            <div class="flex justify-between items-center cursor-pointer">
              <div class="flex items-center justify-between">
                <span><drag-icon /></span>
                <span class="text-sm">Fleet Status</span>
              </div>
              <div>
                <span><view-icon /></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DragIcon from "@/components/UI/svgs/FilterDragIcon";
import ViewIcon from "@/components/UI/svgs/ViewIcon";
export default {
  components: {
    DragIcon,
    ViewIcon,
  },
};
</script>

<style lang="scss" scoped>
.table-filter {
  position: absolute;
  z-index: 999;
  padding: 1rem;
  width: 30rem;
  right: 2rem;
  top: 1rem;
  background: #ffffff;
  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;
}
.row > div > div {
  margin-bottom: 1rem;
}
hr {
  margin: 0.75rem 0;
}
.col-6:first-of-type {
  border-right: 0.5px solid #e6ecf3;
}
.col-6:last-of-type {
  padding-left: 0.75rem;
}
.inactive-filters > div {
  margin-bottom: 1rem;
  opacity: 0.4;
}
</style>
